export default __webpack_public_path__ + "static/media/web2.60c45b3f.jpg";